<div class="header mb-3">
  <div class="product-basic-info-wrapper">
    <!-- we use h1 for SEO purposes but want to have h2 styling applied -->
    <h1 class="h2">{{ product.name }}</h1>

    <ng-container *ngIf="pdpTypeSkuPicker">
      <div class="article-basic-info-wrapper">
        <p class="py-color-grey-500 hide-on-print" [innerText]="article?.displayName"></p>
        <p
          class="hide-on-print"
          *ngIf="{
            enableContractedArticleIcon: enableContractedArticleIcon$ | async,
            enableSecondaryArticleRowVariant: enableSecondaryArticleRowVariant$ | async,
          } as data"
        >
          <ng-container *ngIf="article?.articleNumber">
            {{ 'product.articleNumber_heading' | cxTranslate }}

            <span class="article-code-label">
              {{ article.articleNumber }}

              <ng-template
                *ngIf="!data.enableSecondaryArticleRowVariant && data.enableContractedArticleIcon && article.contracted"
                [ngTemplateOutlet]="contractedArticleIcon"
              ></ng-template>
            </span>

            <span
              *ngIf="data.enableSecondaryArticleRowVariant && data.enableContractedArticleIcon && article.contracted"
              class="contracted-icon-secondary-styling-wrapper"
            >
              <ng-template [ngTemplateOutlet]="contractedArticleIcon"></ng-template>
            </span>
          </ng-container>

          <ng-template #contractedArticleIcon>
            <i
              nz-icon
              class="ml-1"
              nzType="contracted-article"
              container="body"
              [ngbTooltip]="'article.contracted_tooltip' | cxTranslate"
            ></i>
          </ng-template>

          <ng-container *ngIf="product?.articlePickerAttributes?.length > 0 && !article?.articleNumber && !product?.promotional">
            <i nz-icon nzType="info-circle" nzTheme="outline" class="mr-2"></i>{{ 'product.selectAttributes_hint' | cxTranslate }}
          </ng-container>
        </p>
      </div>
    </ng-container>
  </div>

  <div *ngIf="product?.brand?.image" class="brand-wrapper">
    <cx-generic-link [url]="product?.brand?.pageUrl">
      <img [pyMedia]="product?.brand?.image" class="brand" [alt]="product?.brand?.name" [ngbTooltip]="product?.brand?.name" />
    </cx-generic-link>
  </div>
</div>

<div class="badges-wrapper d-flex flex-wrap align-items-center" *ngIf="!!replacementArticle || (hasCertificates$ | async)">
  <py-badge class="mr-2" *ngIf="!!replacementArticle" type="replacement" [tag]="true" large="true">{{
    'catalog.substitute_replacement_badge' | cxTranslate
  }}</py-badge>
  <div *ngFor="let certificate of certificates$ | async" class="certificate mr-3">
    <img [pyMedia]="certificate.icon" [alt]="certificate.name" [ngbTooltip]="certificate.name" />
  </div>
</div>

<ng-container *ngIf="pdpTypeSkuPicker; else templateNoSkuPicker">
  <p class="description my-3">
    <span [innerHTML]="product.description"></span>
  </p>

  <div *ngIf="showReadMore" class="hide-on-print mb-3">
    <button
      *ngIf="product?.articles?.length > 1 && !product?.articlePickerAttributes?.length"
      class="btn btn-primary"
      (click)="clickReadMore(tabTypeArticleList)"
    >
      {{ 'product.viewArticles_action' | cxTranslate }}<i nz-icon nzType="arrow-down" nzTheme="outline"></i>
    </button>

    <button *ngIf="product?.articlePickerAttributes?.length > 0" class="link" (click)="clickReadMore()">
      {{ 'common.readMore_action' | cxTranslate }}
    </button>
  </div>
</ng-container>

<ng-template #templateNoSkuPicker>
  <div class="description my-3">
    <py-read-more *ngIf="product.description" [isDynamic]="true" [showExpandDispandIcon]="false" [content]="product.description">
    </py-read-more>
  </div>

  <button
    *ngIf="product?.articles?.length > 1 && !product?.articlePickerAttributes?.length"
    class="btn btn-primary"
    (click)="clickReadMore(tabTypeArticleList)"
  >
    {{ 'product.viewArticles_action' | cxTranslate }}<i nz-icon nzType="arrow-down" nzTheme="outline"></i>
  </button>
</ng-template>
<ng-container *pyPrincipalConfiguration="'enableSampleOrders'">
  <div *ngIf="product?.sample?.a4SampleAvailable" class="mt-3 hide-on-print">
    <button class="btn btn-ternary d-flex h-100 justify-content-center align-items-center" (click)="openSampleOrderModal()">
      {{ 'product.addSampleOrder_action' | cxTranslate }}
    </button>
  </div>
</ng-container>

<ng-container *ngIf="product?.promotional">
  <div *pyPrincipalConfiguration="'displayInquiryButton'" class="mt-3">
    <button id="inquiry-button" class="btn btn-primary" (click)="openInquiryModal()">
      {{ 'product.inquiry.modal.openModal_action' | cxTranslate }}
    </button>
  </div>
</ng-container>

<ng-container *ngIf="cmsLinkComponents$ | async as cmsLinkComponents">
  <div *ngIf="cmsLinkComponents?.length > 0" class="d-flex flex-column mt-3">
    <div *ngFor="let link of cmsLinkComponents" class="d-flex mb-2" class="cms-link-components">
      <i nz-icon nzType="info-circle" nzTheme="fill" class="mr-2 py-color-primary"></i>
      <cx-generic-link [url]="link.url || link.contentPageLabel" [target]="link.external ? '_blank' : null">
        {{ link.linkName }}
      </cx-generic-link>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!!replacementArticle">
  <py-notification type="info" class="my-3">
    {{ 'article.replacement_hint' | cxTranslate: { code: replacementArticle.code, displayName: replacementArticle.displayName } }}
  </py-notification>
</ng-container>

<div class="my-3" *ngIf="(isUserLoggedIn$ | async) && article?.nonReturnable">
  <py-non-returnable [outOfStock]="outOfStock" [articleStatus]="article?.articleStatus">
    <p class="py-color-grey-500">{{ 'article.nonReturnable_text' | cxTranslate }}</p>
  </py-non-returnable>
</div>
